// Copy shown inside the daily-diary product mock-up (Figma 3165:29712).
// Everything here is decorative: the scene is one `role="img"` for assistive tech.

export const DIARY_UI = {
  breadcrumb: ["Breadcrumb", "Daily Diary"],
  banner: {
    title: "Ready to start trading?",
    text: "Answer a few questions and get on track",
    lastLabel: "Last performance:",
    stats: ["12h 40m", "123 trades", "+$22,7%"],
    button: "Start Trading section",
  },
  pastSections: "Past sections",
  month: "February 2026",
  views: ["List", "Grid", "Calendar"],
  weekdays: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
  today: "Today",
  pnlLabel: "P&L",
} as const;

export type DiaryTone = "green" | "orange" | "red";

export type DiaryDay = {
  day: string;
  /** Previous / next month: dimmed. */
  outside?: boolean;
  /** Filled-in diary entry. */
  entry?: { pnl: string; time: string; score: string; tone: DiaryTone };
  today?: boolean;
  /** Position in the fill-in choreography (chronological). */
  order?: number;
};

const outsideEntry = (pnl: string, time: string, score: string) => ({ pnl, time, score, tone: "green" as const });

// February 2026 starting on the Monday before the 1st; "today" is Tuesday 10 Feb.
export const DIARY_WEEKS: DiaryDay[][] = [
  [
    { day: "26", outside: true },
    { day: "27", outside: true, entry: outsideEntry("+$22,7%", "12h 45min", "87"), order: 0 },
    { day: "28", outside: true, entry: outsideEntry("+$22,7%", "12h 45min", "87"), order: 1 },
    { day: "29", outside: true, entry: outsideEntry("+$22,7%", "12h 45min", "87"), order: 2 },
    { day: "30", outside: true, entry: outsideEntry("+$22,7%", "12h 45min", "87"), order: 3 },
    { day: "31", outside: true, entry: outsideEntry("+$22,7%", "12h 45min", "87"), order: 4 },
    { day: "01", entry: outsideEntry("+$22,7%", "12h 45min", "87"), order: 5, outside: true },
  ],
  [
    { day: "02" },
    { day: "03", entry: { pnl: "+$8,2%", time: "9h 10min", score: "74", tone: "orange" }, order: 6 },
    { day: "04", entry: { pnl: "+$22,7%", time: "12h 45min", score: "91", tone: "green" }, order: 7 },
    { day: "05", entry: { pnl: "+$4,9%", time: "7h 30min", score: "68", tone: "orange" }, order: 8 },
    { day: "06", entry: { pnl: "-$6,3%", time: "11h 05min", score: "52", tone: "red" }, order: 9 },
    { day: "07", entry: { pnl: "-$2,1%", time: "6h 20min", score: "61", tone: "red" }, order: 10 },
    { day: "08", entry: { pnl: "+$11,5%", time: "8h 55min", score: "83", tone: "green" }, order: 11 },
  ],
  [
    { day: "09", entry: { pnl: "+$22,7%", time: "12h 45min", score: "87", tone: "green" }, order: 12 },
    { day: "10", entry: { pnl: "+$3,4%", time: "4h 15min", score: "79", tone: "orange" }, order: 13, today: true },
    { day: "11" },
    { day: "12" },
    { day: "13" },
    { day: "14" },
    { day: "15" },
  ],
  [{ day: "16" }, { day: "17" }, { day: "18" }, { day: "19" }, { day: "20" }, { day: "21" }, { day: "22" }],
  [{ day: "23" }, { day: "24" }, { day: "25" }, { day: "26" }, { day: "27" }, { day: "28" }, { day: "01", outside: true }],
];

export const DIARY_FILLED = DIARY_WEEKS.flat().filter((d) => d.order !== undefined).length;
